import template from './buttons.html' with { type: 'html' };

export default {
	name: 'CButtons',
	props: {
		isAdditionalTop: {
			type: Boolean,
			default: false
		},
		isLoading: {
			type: Boolean,
			default: false
		}
	},
	template
};
